import Http from "./http";

export const updateTermsAndConditionsStatusAPI = (payload) => {
  return Http.post("/admin/campaign/terms-condition/status", payload);
};

